import Query from '~/scripts/services/model/query';

/* globals KtableFormConfig */

/** @type {KtableFormConfig.Settings} */
export const settings = {
	disabled:  false,
	label:     'K-Table',
	hideLabel: true,
	input:     false,
	tableView: false,
	// extra widget actions
	actions:   [],
	options:   {
		actions:     {
			delete:         true,
			export:         true,
			fastImport:     false,
			filters:        false,
			insertCreate:   true,
			insertExisting: true,
			refresh:        true,
			update:         true,
			updateCell:     false,
			upload:         false,
		},
		display:     {
			status: true,
		},
		height:      5,
		mode:        'normal',
		packet_size: 50,
		parent:      undefined,
		table:       {
			persistentSort: false,
		},
		target: null,
	},
	query:     new Query(),
	validate:  {
		card: '0-N',
	},
};
